import { CellBox } from "./CellBox";
import { DerivedAccountChip } from "../DerivedAccountChip";
import type { DerivedAccount } from "../../api/types";

export type AccountCellProps = {
  value: DerivedAccount | null;
  pending: boolean;
};

/**
 * The Account cell shows the account the server derived for the row. There
 * is no stored field behind it, so the cell is read-only: no picker opens.
 */
export const AccountCell = ({ value, pending }: AccountCellProps) => (
  <CellBox pending={pending}>
    <DerivedAccountChip value={value} size="small" />
  </CellBox>
);
